var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore2Fill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7111 4.92773C17.9042 4.92773 16.4258 6.40611 16.4258 8.21302C16.4258 10.0199 17.9042 11.4983 19.7111 11.4983C21.518 11.4983 22.9964 10.0199 22.9964 8.21302C22.9964 6.40611 21.518 4.92773 19.7111 4.92773ZM19.7111 27.9247C17.9042 27.9247 16.4258 29.4031 16.4258 31.21C16.4258 33.0169 17.9042 34.4953 19.7111 34.4953C21.518 34.4953 22.9964 33.0169 22.9964 31.21C22.9964 29.4031 21.518 27.9247 19.7111 27.9247ZM19.7111 16.4262C17.9042 16.4262 16.4258 17.9046 16.4258 19.7115C16.4258 21.5184 17.9042 22.9968 19.7111 22.9968C21.518 22.9968 22.9964 21.5184 22.9964 19.7115C22.9964 17.9046 21.518 16.4262 19.7111 16.4262Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore2Fill);
export default __webpack_public_path__ + "static/media/more-2-fill.4f8a7483c01b5607489674bf9f44b653.svg";
export { ForwardRef as ReactComponent };